"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_options_core_1 = require("owa-options-core");
var owa_calendar_configuration_1 = require("owa-calendar-configuration");
var owa_calendar_configuration_2 = require("owa-calendar-configuration");
/**
 * Action called when we save the txp options
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('saveTxpOption')(function saveTxpOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, savedOptionState, mailboxConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState;
                    savedOptionState = owa_calendar_configuration_2.getCalendarConfiguration();
                    mailboxConfiguration = {
                        CreateEventsFromEmailAsPrivate: owa_options_core_1.getFallbackValueIfNull(optionState.CreateEventsFromEmailAsPrivate, savedOptionState.CreateEventsFromEmailAsPrivate),
                        EventsFromEmailEnabled: owa_options_core_1.getFallbackValueIfNull(optionState.EventsFromEmailEnabled, savedOptionState.EventsFromEmailEnabled),
                    };
                    // Push the rest of the events to the mailboxConfiguration
                    Object.keys(optionState.Events).map(function (eventType) {
                        var val = owa_options_core_1.getFallbackValueIfNull(optionState.Events[eventType], savedOptionState[eventType]);
                        mailboxConfiguration[eventType] = val;
                    });
                    return [4 /*yield*/, owa_calendar_configuration_1.saveCalendarMailboxConfiguration(mailboxConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveTxpOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-txp-option/lib/actions/saveTxpOption.js
// module id = 5268
// module chunks = 2